import cropDraftReducer from './cropDraftReducer'

const applicationDraftReducers = {
    cropDraft: cropDraftReducer
}

export default  applicationDraftReducers;